import { getWindow as K, prop as x, makeProviderMark as Q, computedOf as J, Signal as pt, Use as N, html as j, on as ft, Value as k, attr as X, Empty as _, OneOfType as mt, WithElement as O, OnDispose as b, Fragment as R, Portal as gt, renderableOfTNode as vt, When as wt, previousSignal as Ot, effectOf as Lt, WithBrowserCtx as Rt, WithCtx as At, OneOfTuple as yt, Provide as Ht, Prop as Tt, strictEquals as Wt } from "@tempots/dom";
import { delayed as St, AsyncResult as v, nearEqual as T, interval as Ut } from "@tempots/std";
import { autoUpdate as Kt, flip as Mt, offset as Dt, shift as Nt, computePosition as Ft, arrow as Ct } from "@floating-ui/dom";
const zt = (e) => {
  const t = e.split("/").pop();
  if (t == null || t.startsWith(".")) return;
  const n = t.split(".") || [];
  return n.length > 1 ? "." + n.pop() : void 0;
}, Vt = (e, t) => {
  const n = zt(t);
  return n != null && (e.length === 0 || !e.some((s) => n == s));
}, $t = (e, t, n, s) => {
  let a = e.target;
  for (; a != null && !(a instanceof HTMLAnchorElement); )
    a = a.parentElement;
  if (a == null)
    return !0;
  const o = a;
  if (e.button !== 0 || e.ctrlKey || e.metaKey || o.target !== "_self" && o.target !== "" || o.getAttribute("download") != null)
    return !0;
  const { pathname: r, search: i, hash: c } = o;
  if (s) {
    const u = r + i + c, h = o.getAttribute("href");
    if (!h?.startsWith("#") && h !== u)
      return !0;
  }
  return t ? !1 : Vt(n, r);
}, jt = (e, t = {
  ignoreUrlWithExtension: !0,
  allowedExtensions: [],
  ignoreExternalUrl: !0
}) => {
  const n = t.ignoreUrlWithExtension === !0 && Array.isArray(t.allowedExtensions) ? t.allowedExtensions.map(
    (s) => s.startsWith(".") ? s : "." + s
  ) : [];
  return (s) => {
    $t(
      s,
      t.ignoreUrlWithExtension ?? !0,
      n,
      t.ignoreExternalUrl ?? !0
    ) || e() && s.preventDefault();
  };
}, _t = (e, t) => e.pathname === t.pathname && JSON.stringify(e.search) === JSON.stringify(t.search) && e.hash === t.hash, I = (e, t) => {
  const n = new URL(e, t ?? K()?.location.toString()), s = Object.fromEntries(n.searchParams?.entries() ?? []);
  let a = n.hash;
  return a.startsWith("#") && (a = a.substring(1)), {
    pathname: n.pathname,
    search: s,
    hash: a === "" ? void 0 : a
  };
}, U = (e) => {
  const n = new URLSearchParams(e.search).toString(), s = e.hash;
  return `${e.pathname}${n ? `?${n}` : ""}${s ? `#${s}` : ""}`;
}, It = (e) => {
  document.startViewTransition ? document.startViewTransition(e) : e();
}, st = () => {
  const e = K(), t = e?.location.hash ?? "";
  return {
    pathname: e?.location.pathname ?? "",
    search: Object.fromEntries(
      new URLSearchParams(e?.location.search ?? "").entries()
    ),
    hash: t.startsWith("#") ? t.substring(1) || void 0 : t === "" ? void 0 : t
  };
}, rt = (e) => {
  if (e?.scroll !== "auto")
    return;
  const t = K();
  t && t.requestAnimationFrame(
    () => t.scrollTo({ top: 0, left: 0, behavior: "auto" })
  );
}, at = (e, t) => {
  t?.viewTransition ? It(e) : e();
}, Bt = () => {
  const e = x(st(), _t), t = K(), n = () => {
    e.set(st());
  };
  t?.addEventListener("popstate", n), t?.addEventListener("hashchange", n);
  const s = (c, u, h) => {
    at(() => {
      if (t) {
        const w = U(c), f = u?.state ?? {};
        h === "replaceState" || u?.replace ? t.history.replaceState(f, "", w) : t.history.pushState(f, "", w);
      }
      e.set(c);
    }, u), rt(u);
  }, a = (c, u) => {
    at(() => {
      t?.history.go(c);
    }, u), rt(u);
  };
  return {
    location: e,
    commit: s,
    go: a,
    back: (c) => a(-1, c),
    forward: (c) => a(1, c),
    resolve: (c) => I(c),
    dispose: () => {
      t?.removeEventListener("popstate", n), t?.removeEventListener("hashchange", n), e.dispose();
    }
  };
}, qt = (e) => e.startsWith("http://") || e.startsWith("https://") || e.startsWith("//"), Yt = (e) => {
  const t = e.container.currentURL, n = t.iso(
    (r) => I(r, t.value),
    (r) => {
      if (qt(r.pathname))
        return U(r);
      const i = new URL(r.pathname, t.value), c = i.origin + i.pathname;
      return U({ ...r, pathname: c });
    }
  );
  return {
    location: n,
    dispose: () => {
      n.dispose();
    },
    commit: (r, i, c) => {
      n.set(r);
    },
    go: (r, i) => {
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    back: (r) => {
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    forward: (r) => {
    },
    resolve: (r) => I(r, t.value)
  };
}, M = (e) => ({
  pathname: e.pathname,
  search: { ...e.search },
  hash: e.hash ?? void 0
}), B = (e) => {
  if (e == null) return;
  const t = `${e}`;
  return t === "" ? void 0 : t;
}, kt = (e, t) => {
  const n = { ...e };
  for (const [s, a] of Object.entries(t))
    a == null ? delete n[s] : n[s] = a;
  return n;
}, Qt = (e, t) => {
  const n = t?.includeSearch ?? !0, s = t?.includeHash ?? !0, a = t?.ignoreSearchParams ?? [];
  let o;
  if (!n)
    o = {};
  else if (a.length === 0)
    o = { ...e.search };
  else {
    const r = new Set(a);
    o = {};
    for (const [i, c] of Object.entries(e.search))
      r.has(i) || (o[i] = c);
  }
  return {
    pathname: e.pathname,
    search: o,
    hash: s ? e.hash : void 0
  };
}, ot = (e, t, n) => {
  const s = Qt(e, n);
  return typeof t == "string" ? U(s) === t : t instanceof RegExp ? ((t.global || t.sticky) && (t.lastIndex = 0), t.test(U(s))) : t(s);
};
class Jt {
  constructor(t) {
    this.current = t;
  }
  get location() {
    return this.current;
  }
  setLocation(t) {
    return this.current = M(t), this;
  }
  setPathname(t) {
    return this.current = {
      ...this.current,
      pathname: t
    }, this;
  }
  setHash(t) {
    const n = B(t);
    if (n == null) {
      const { hash: s, ...a } = this.current;
      this.current = a;
    } else
      this.current = {
        ...this.current,
        hash: n
      };
    return this;
  }
  clearHash() {
    const { hash: t, ...n } = this.current;
    return this.current = n, this;
  }
  setSearch(t) {
    return this.current = {
      ...this.current,
      search: kt(this.current.search, t)
    }, this;
  }
  setSearchParam(t, n) {
    return this.setSearch({ [t]: n });
  }
  updateSearch(t) {
    return this.current = {
      ...this.current,
      search: { ...t({ ...this.current.search }) }
    }, this;
  }
}
const Xt = (e, t) => e?.replace ? "replaceState" : t, Gt = (e) => {
  const t = e.location, n = t.map(U), s = t.map((l) => l.pathname), a = t.map((l) => ({ ...l.search })), o = t.map((l) => l.hash), r = (l, d) => ot(e.location.value, l, d), i = (l, d) => J(
    t,
    l
  )(
    (p, H) => ot(p, H, d)
  ), c = (l, d, p) => {
    const H = M({
      ...l,
      hash: B(l.hash ?? void 0)
    });
    e.commit(H, d, p);
  }, u = (l, d) => {
    const p = Xt(d, "pushState");
    c(l, d, p);
  }, h = (l, d) => {
    const p = l(M(e.location.value));
    u(p, d);
  }, w = (l, d) => {
    const p = e.resolve(l);
    u(p, d);
  }, f = (l, d) => {
    const p = { ...d, replace: !0 };
    w(l, p);
  }, A = (l, d) => {
    e.go(l, d);
  }, g = (l) => {
    e.back(l);
  }, P = (l) => {
    e.forward(l);
  }, m = (l, d) => h((p) => ({ ...p, pathname: l }), d), E = (l, d) => h((p) => {
    const H = { ...p }, nt = B(l);
    return nt == null ? delete H.hash : H.hash = nt, H;
  }, d), S = (l) => E(void 0, l), y = (l, d) => h(
    (p) => ({
      ...p,
      search: kt(p.search, l)
    }),
    d
  );
  return {
    handle: {
      location: t,
      url: n,
      pathname: s,
      search: a,
      hash: o,
      setLocation: u,
      updateLocation: h,
      navigate: w,
      replace: f,
      go: A,
      back: g,
      forward: P,
      setPathname: m,
      setHash: E,
      clearHash: S,
      setSearch: y,
      setSearchParam: (l, d, p) => y({ [l]: d }, p),
      updateSearch: (l, d) => h(
        (p) => ({
          ...p,
          search: { ...l({ ...p.search }) }
        }),
        d
      ),
      queryParam: (l) => t.map((d) => d.search[l]),
      run: (l, d) => {
        const p = new Jt(
          M(e.location.value)
        );
        l(p), u(M(p.location), d);
      },
      match: r,
      matchSignal: i
    },
    dispose: () => {
      e.dispose(), n.dispose(), s.dispose(), a.dispose(), o.dispose();
    }
  };
}, Zt = (e) => {
  if (e.isBrowser())
    return Bt();
  if (e.isHeadless())
    return Yt(e);
  throw new Error("Unknown context");
}, G = {
  mark: Q("Location"),
  create: (e, t) => {
    const n = Zt(t), { handle: s, dispose: a } = Gt(n);
    return {
      value: s,
      dispose: a
    };
  }
}, te = (e, ...t) => {
  if (typeof e == "string" || pt.is(e))
    return te({ href: e }, ...t);
  const { href: n, state: s, scroll: a, viewTransition: o, replace: r, ...i } = e;
  return N(G, (c) => j.a(
    ft.click(
      jt(() => {
        let u = !1;
        const h = {};
        return s !== void 0 && (h.state = s, u = !0), a !== void 0 && (h.scroll = a, u = !0), o !== void 0 && (h.viewTransition = o, u = !0), r !== void 0 && (h.replace = r, u = !0), c.navigate(
          k.get(n),
          u ? h : void 0
        ), !0;
      }, i)
    ),
    X.href(n),
    ...t
    /* c8 ignore next 2 */
  ));
}, Oe = {
  mark: Q("Appearance"),
  create: () => {
    const e = ee();
    return {
      value: e,
      dispose: () => e.dispose()
    };
  }
};
function ee() {
  const e = K(), t = e != null && e.matchMedia != null ? e.matchMedia("(prefers-color-scheme: dark)") : void 0, n = t?.matches ?? !1, s = x(n ? "dark" : "light"), a = (o) => s.set(o.matches ? "dark" : "light");
  return t?.addEventListener("change", a), s.onDispose(() => t?.removeEventListener("change", a)), s;
}
const xt = (e, t) => {
  if (typeof t == "function")
    return xt(e, { success: t });
  const n = t.failure ?? ((r) => r.map((i) => `Error: ${i}`)), s = t.success, a = t.loading ?? (() => _), o = t.notAsked ?? (() => _);
  return mt(k.toSignal(e), {
    AsyncSuccess: (r) => s(r.$.value),
    AsyncFailure: (r) => n(r.$.error),
    Loading: (r) => a(r.map((i) => i.previousValue)),
    NotAsked: o
  });
}, Le = (e = 10) => O((t) => b(St(() => t?.focus(), e))), Re = (e = 10) => O((t) => {
  const n = St(() => t.select(), e);
  return b(n);
});
function Ae(e) {
  const t = Object.entries(e);
  return R(
    ...t.map(
      ([n, s]) => X.class(k.map(s, (a) => a ? n : void 0))
    )
  );
}
const He = O((e) => {
  const t = e.style.getPropertyValue(":empty");
  return e.style.setProperty(":empty", "display:none"), b((n) => {
    n && e.style.setProperty(":empty", t);
  });
}), Te = (e) => gt("head > title", X.innerText(e)), ne = {
  partial: {
    root: null,
    rootMargin: "0px",
    threshold: 0
  },
  full: {
    root: null,
    rootMargin: "0px",
    threshold: 1
  }
}, C = {
  partial: /* @__PURE__ */ new Map(),
  full: /* @__PURE__ */ new Map()
}, D = {
  partial: null,
  full: null
};
function se(e) {
  return D[e] == null && (D[e] = new IntersectionObserver((t) => {
    t.forEach((n) => {
      C[e].get(n.target)?.set(n.isIntersecting);
    });
  }, ne[e])), D[e];
}
const re = ({ mode: e = "partial", once: t = !1 }, n) => {
  const s = x(!1);
  return R(
    O((a) => {
      const o = typeof IntersectionObserver < "u" ? se(e) : null;
      C[e].set(a, s), o?.observe(a);
      function r() {
        o?.unobserve(a), C[e].delete(a), C[e].size === 0 && (D[e]?.disconnect(), D[e] = null);
      }
      let i = null;
      return t && (i = s.on((c) => {
        c && r();
      })), b(() => {
        s.dispose(), r(), i?.();
      });
    }),
    vt(n(s))
  );
}, We = (e, t, n) => re(e, (s) => wt(s, t, n ?? (() => _)));
function ae(e) {
  return O((t) => {
    const n = (s) => {
      t.contains(s.target) || e(s);
    };
    return document.addEventListener("click", n), b(() => {
      document.removeEventListener("click", n);
    });
  });
}
const W = (e, t) => e === void 0 || e === t, it = (e, t) => e === void 0 || e === t;
function oe(e, t) {
  return typeof e == "string" ? t.key === e : it(e.key, t.key) && it(e.code, t.code) && W(e.ctrlKey, t.ctrlKey) && W(e.altKey, t.altKey) && W(e.shiftKey, t.shiftKey) && W(e.metaKey, t.metaKey) && W(e.repeat, t.repeat) && W(
    e.commandOrControlKey,
    t.metaKey || t.ctrlKey
  );
}
function bt({
  allowedKeys: e,
  handler: t
}) {
  return O((n) => {
    const s = (a) => {
      if (n.contains(a.target)) {
        for (const o of e)
          if (oe(o, a)) {
            t(a);
            break;
          }
      }
    };
    return document.addEventListener("keydown", s), b(() => {
      document.removeEventListener("keydown", s);
    });
  });
}
function Ue(e) {
  return bt({ allowedKeys: ["Enter"], handler: e });
}
function Ke(e) {
  return bt({ allowedKeys: ["Escape"], handler: e });
}
const ie = ({
  mutate: e,
  convertError: t,
  onSuccess: n,
  onError: s,
  onSettled: a
}) => {
  let o;
  const r = x(v.notAsked), i = r.map(
    (g) => v.isSuccess(g) ? g.value : void 0
  ), c = r.map(
    (g) => v.isFailure(g) ? g.error : void 0
  ), u = r.map((g) => v.isLoading(g)), h = () => {
    o?.abort(), o = void 0;
  }, w = (g) => {
    h(), r.set(g ?? v.notAsked);
  };
  return {
    status: r,
    value: i,
    error: c,
    pending: u,
    execute: async (g, P) => {
      h(), o = new AbortController();
      const m = o.signal, E = r.get(), S = P?.optimisticValue ?? (P?.optimisticFromRequest != null ? P.optimisticFromRequest(g) : void 0);
      S != null ? r.set(v.loading(S)) : r.set(v.loading(v.getOrUndefined(E)));
      try {
        const y = await e({ request: g, abortSignal: m, previous: E, cancel: w });
        o = void 0, r.set(v.success(y)), n?.(y, g);
      } catch (y) {
        o = void 0;
        const L = t(y);
        r.set(v.failure(L)), s?.(L, g);
      }
      a?.(r.get(), g);
    },
    cancel: w,
    dispose: () => {
      o?.abort(), o = void 0, r.dispose();
    }
  };
}, ce = (e, t) => {
  const { status: n, dispose: s, execute: a, cancel: o, pending: r, error: i, value: c } = e, { content: u } = t, h = Ot(c);
  return R(
    b(s),
    u({
      previous: h,
      execute: a,
      cancel: o,
      pending: r,
      error: i,
      value: c,
      status: n
    })
  );
}, Me = ({
  mutate: e,
  convertError: t = (r) => r,
  onSuccess: n,
  onError: s,
  onSettled: a,
  content: o
}) => {
  const r = ie({
    mutate: e,
    convertError: t,
    onSuccess: n,
    onError: s,
    onSettled: a
  });
  return ce(r, { content: o });
}, De = [
  "top",
  "top-start",
  "top-end",
  "right",
  "right-start",
  "right-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "left",
  "left-start",
  "left-end"
], Ne = (e, t = { isOpen: !1 }) => {
  let n = null;
  const s = k.deriveProp(t.isOpen);
  function a(r) {
    n = r, s.set(!0);
  }
  function o() {
    s.set(!1);
  }
  return R(
    e(a, o),
    wt(
      s,
      () => R(
        n?.onClickOutside != null ? ae(n.onClickOutside) : null,
        O(
          (r) => gt(
            "body",
            j.div(
              O((i) => {
                i.style.position = "absolute", i.style.width = "max-content";
                const c = typeof n?.target == "string" ? r.querySelector(
                  n.target
                ) : n?.target ?? r;
                if (c == null)
                  throw new Error(`Target not found: ${n?.target}`);
                let u = null;
                const h = k.toSignal(n?.mainAxisOffset ?? 0), w = k.toSignal(
                  n?.crossAxisOffset ?? 0
                ), f = k.toSignal(
                  /* c8 ignore next 3 */
                  n?.placement ?? "top"
                ), A = k.toSignal(
                  n?.arrowPadding ?? 0
                ), g = n?.arrow, P = x({
                  centerOffset: 0,
                  alignmentOffset: 0,
                  containerWidth: 0,
                  containerHeight: 0,
                  x: void 0,
                  y: void 0
                });
                async function m() {
                  const S = [
                    Mt(),
                    Dt({
                      mainAxis: h.get(),
                      crossAxis: w.get()
                    }),
                    Nt()
                  ];
                  g != null && u != null && S.push(
                    Ct({
                      element: u,
                      padding: A.get()
                    })
                  );
                  const y = await Ft(c, i, {
                    placement: f.get(),
                    strategy: "absolute",
                    middleware: S
                  }), { x: L, y: Z, middlewareData: $ } = y;
                  if (i.style.top = `${Z}px`, i.style.left = `${L}px`, u != null && $.arrow != null) {
                    const {
                      x: tt,
                      y: et,
                      centerOffset: l,
                      alignmentOffset: d
                    } = $.arrow;
                    P.set({
                      x: tt,
                      y: et,
                      centerOffset: l,
                      alignmentOffset: d,
                      containerWidth: i.offsetWidth,
                      containerHeight: i.offsetHeight
                    });
                  }
                }
                const E = Lt(
                  h,
                  w,
                  f
                )(m);
                return R(
                  n?.content,
                  n?.arrow != null ? j.div(
                    n?.arrow(
                      J(
                        P,
                        f
                      )(
                        (S, y) => ({
                          ...S,
                          placement: y
                        })
                      )
                    ),
                    O((S) => {
                      u = S, m();
                    })
                  ) : null,
                  // arrowSignal is automatically disposed by the scope
                  b(
                    Kt(c, i, m),
                    E
                  )
                );
              })
            )
          )
        )
      )
    )
  );
}, le = ({
  request: e,
  load: t,
  convertError: n,
  onSuccess: s,
  onError: a,
  onSettled: o
}) => {
  let r;
  const i = x(v.notAsked), c = i.map(
    (m) => v.isSuccess(m) ? m.value : void 0
  ), u = i.map(
    (m) => v.isFailure(m) ? m.error : void 0
  ), h = i.map((m) => v.isLoading(m)), w = () => {
    r?.abort(), r = void 0;
  }, f = (m) => {
    w(), i.set(m ?? v.notAsked);
  }, A = async (m) => {
    w(), r = new AbortController();
    const E = r.signal, S = i.get();
    i.set(v.loading(v.getOrUndefined(S)));
    try {
      const y = await t({
        request: m,
        abortSignal: E,
        previous: S,
        cancel: f
      });
      await Promise.resolve(), r = void 0, i.set(v.success(y)), s?.(y, m);
    } catch (y) {
      r = void 0;
      const L = n(y);
      i.set(v.failure(L)), a?.(L, m);
    }
    o?.(i.get(), m);
  }, g = () => A(k.get(e)), P = () => {
    r?.abort(), r = void 0, i.dispose();
  };
  return i.onDispose(k.on(e, A)), {
    status: i,
    value: c,
    error: u,
    loading: h,
    cancel: f,
    reload: g,
    dispose: P
  };
}, ue = (e, t) => {
  const { status: n, dispose: s, reload: a, loading: o } = e, {
    notAsked: r,
    pending: i,
    failure: c,
    success: u,
    keepOnReload: h = !1
  } = t, w = h ? n.map((f) => v.isLoading(f) && f.previousValue !== void 0 ? v.success(f.previousValue) : f) : n;
  return R(
    b(s),
    xt(w, {
      notAsked: r,
      loading: i != null ? (f) => i({ previous: f, reload: a, cancel: e.cancel }) : void 0,
      failure: c != null ? (f) => c({ error: f, reload: a }) : void 0,
      success: (f) => u({ value: f, reload: a, loading: o })
    })
  );
}, Fe = ({
  request: e,
  load: t,
  convertError: n = (w) => w,
  onSuccess: s,
  onError: a,
  onSettled: o,
  notAsked: r,
  success: i,
  pending: c,
  failure: u,
  keepOnReload: h
}) => {
  const w = le({
    request: e,
    load: t,
    convertError: n,
    onSuccess: s,
    onError: a,
    onSettled: o
  });
  return ue(w, {
    notAsked: r,
    success: i,
    pending: c,
    failure: u,
    keepOnReload: h
  });
}, he = (e, t) => {
  if (typeof t == "function")
    return he(e, { success: t });
  const n = t.failure ?? ((a) => (a.on(console.error), a.map((o) => `Error: ${o}`))), s = t.success;
  return mt(k.toSignal(e), {
    Success: (a) => s(a.$.value),
    Failure: (a) => n(a.$.error)
  });
}, Ce = () => ft.focus((e) => e.target?.select());
class V {
  /**
   * Creates a new Rect instance.
   *
   * @param left - The x-coordinate of the left edge
   * @param top - The y-coordinate of the top edge
   * @param width - The width of the rectangle
   * @param height - The height of the rectangle
   *
   * @example
   * ```typescript
   * const rect = new Rect(10, 20, 100, 50);
   * console.log(rect.left);   // 10
   * console.log(rect.top);    // 20
   * console.log(rect.width);  // 100
   * console.log(rect.height); // 50
   * ```
   */
  constructor(t, n, s, a, o, r) {
    this.left = t, this.top = n, this.width = s, this.height = a, this.localLeft = o, this.localTop = r;
  }
  /**
   * Creates a new Rect instance using an object with optional properties.
   *
   * This factory method provides a convenient way to create rectangles with
   * default values for any unspecified properties.
   *
   * @param options - Object containing rectangle properties
   * @param options.left - The x-coordinate of the left edge (default: 0)
   * @param options.top - The y-coordinate of the top edge (default: 0)
   * @param options.width - The width of the rectangle (default: 0)
   * @param options.height - The height of the rectangle (default: 0)
   * @returns A new Rect instance
   *
   * @example
   * ```typescript
   * // Create a rectangle at origin with no size
   * const emptyRect = Rect.of({});
   *
   * // Create a rectangle with only position
   * const positioned = Rect.of({ left: 10, top: 20 });
   *
   * // Create a rectangle with all properties
   * const fullRect = Rect.of({ left: 10, top: 20, width: 100, height: 50 });
   * ```
   */
  static of({
    left: t = 0,
    top: n = 0,
    width: s = 0,
    height: a = 0,
    localLeft: o = 0,
    localTop: r = 0
  }) {
    return new V(t, n, s, a, o, r);
  }
  /**
   * Gets the x-coordinate of the right edge of the rectangle.
   *
   * @returns The right edge position (left + width)
   *
   * @example
   * ```typescript
   * const rect = new Rect(10, 20, 100, 50);
   * console.log(rect.right); // 110
   * ```
   */
  get right() {
    return this.left + this.width;
  }
  /**
   * Gets the y-coordinate of the bottom edge of the rectangle.
   *
   * @returns The bottom edge position (top + height)
   *
   * @example
   * ```typescript
   * const rect = new Rect(10, 20, 100, 50);
   * console.log(rect.bottom); // 70
   * ```
   */
  get bottom() {
    return this.top + this.height;
  }
  /**
   * Gets the center point of the rectangle.
   *
   * @returns An object with x and y coordinates of the center point
   *
   * @example
   * ```typescript
   * const rect = new Rect(10, 20, 100, 50);
   * const center = rect.center;
   * console.log(center.x); // 60 (left + width/2)
   * console.log(center.y); // 45 (top + height/2)
   * ```
   */
  get center() {
    return {
      x: this.left + this.width / 2,
      y: this.top + this.height / 2
    };
  }
  /**
   * Gets the center point of the rectangle relative to the parent.
   *
   * @returns An object with x and y coordinates of the center point
   *
   * @example
   * ```typescript
   * const rect = new Rect(10, 20, 100, 50, 5, 10);
   * const localCenter = rect.localCenter;
   * console.log(localCenter.x); // 55 (localLeft + width/2)
   * console.log(localCenter.y); // 65 (localTop + height/2)
   * ```
   */
  get localCenter() {
    return {
      x: this.localLeft + this.width / 2,
      y: this.localTop + this.height / 2
    };
  }
  /**
   * Gets the bottom edge of the rectangle relative to the parent.
   *
   * @returns The bottom edge position (localTop + height)
   *
   * @example
   * ```typescript
   * const rect = new Rect(10, 20, 100, 50, 5, 10);
   * console.log(rect.localBottom); // 60 (localTop + height)
   * ```
   */
  get localBottom() {
    return this.localTop + this.height;
  }
  /**
   * Gets the right edge of the rectangle relative to the parent.
   *
   * @returns The right edge position (localLeft + width)
   *
   * @example
   * ```typescript
   * const rect = new Rect(10, 20, 100, 50, 5, 10);
   * console.log(rect.localRight); // 105 (localLeft + width)
   * ```
   */
  get localRight() {
    return this.localLeft + this.width;
  }
  /**
   * Gets the size dimensions of the rectangle.
   *
   * @returns An object containing width and height properties
   *
   * @example
   * ```typescript
   * const rect = new Rect(10, 20, 100, 50);
   * const size = rect.size;
   * console.log(size.width);  // 100
   * console.log(size.height); // 50
   * ```
   */
  get size() {
    return { width: this.width, height: this.height };
  }
  /**
   * Compares this rectangle with another rectangle for equality.
   *
   * Uses near-equality comparison for floating-point precision tolerance.
   * Two rectangles are considered equal if all their corresponding properties
   * (left, top, width, height) are nearly equal within a small tolerance.
   *
   * @param other - The rectangle to compare with
   * @returns True if the rectangles are equal, false otherwise
   *
   * @example
   * ```typescript
   * const rect1 = new Rect(10, 20, 100, 50);
   * const rect2 = new Rect(10, 20, 100, 50);
   * const rect3 = new Rect(10.00000001, 20, 100, 50); // Very close values
   *
   * console.log(rect1.equals(rect2)); // true
   * console.log(rect1.equals(rect3)); // true (within tolerance)
   * ```
   */
  equals = (t) => T(this.left, t.left) && T(this.top, t.top) && T(this.width, t.width) && T(this.height, t.height) && T(this.localLeft, t.localLeft) && T(this.localTop, t.localTop);
}
function ct(e) {
  const t = e.getBoundingClientRect();
  return V.of({
    top: t.top + window.scrollY,
    left: t.left + window.scrollX,
    width: t.width,
    height: t.height,
    localLeft: e.offsetLeft,
    localTop: e.offsetTop
  });
}
const ze = (e) => Rt((t) => {
  const { element: n } = t, s = x(ct(n), (i, c) => i.equals(c)), a = vt(e(s)).render(t), o = () => s.set(V.of(ct(n)));
  let r = null;
  return typeof ResizeObserver < "u" && (r = new ResizeObserver(o)), r?.observe(n), b((i) => {
    r?.disconnect(), a(i);
  });
});
function lt(e) {
  return {
    /* c8 ignore next 6 */
    width: e?.innerWidth ?? 0,
    height: e?.innerHeight ?? 0
  };
}
const Ve = (e) => At(() => {
  const t = K(), n = x(
    lt(t),
    (a, o) => a.width === o.width && a.height === o.height
  ), s = () => n.set(lt(t));
  return t?.addEventListener("resize", s), R(
    b(() => {
      t?.removeEventListener("resize", s);
    }),
    e(n)
  );
}), de = (e, t) => {
  const n = t.split("/").filter((o) => o !== ""), s = (o) => {
    try {
      return decodeURIComponent(o);
    } catch {
      return o;
    }
  }, a = {};
  for (let o = 0; o < e.length; o++) {
    const r = e[o], i = n[o];
    if (!i && r.type !== "catch-all")
      return null;
    if (r.type === "literal") {
      if (r.value !== i)
        return null;
    } else if (r.type === "param")
      a[r.name] = s(i);
    else if (r.type === "catch-all") {
      if (r.name) {
        const c = n.slice(o).join("/");
        a[r.name] = s(c);
      }
      return { params: a, path: t };
    }
  }
  return n.length !== e.length ? null : { params: a, path: t };
}, Pt = (e) => e.split("/").map((t) => {
  if (t.startsWith(":"))
    return { type: "param", name: t.slice(1) };
  if (t.startsWith("*")) {
    const n = t.slice(1);
    return n != "" ? { type: "catch-all", name: n } : { type: "catch-all" };
  } else
    return { type: "literal", value: t };
}).filter((t) => t.type !== "literal" || t.value !== ""), $e = (e) => {
  const t = e.map((n) => {
    const s = Pt(n);
    return { route: n, segments: s };
  });
  return function(s) {
    for (const { segments: a, route: o } of t) {
      const r = de(a, s);
      if (r)
        return { ...r, route: o };
    }
    return null;
  };
}, pe = (e) => {
  if (e == null)
    throw new Error(
      "NavigationService: no Location handle attached. Make sure to attach one before calling navigation helpers."
    );
  return e;
};
class fe {
  handles = [];
  attach(t) {
    const n = this.handles.lastIndexOf(t);
    return n !== -1 && this.handles.splice(n, 1), this.handles.push(t), () => this.detach(t);
  }
  detach(t) {
    for (let n = this.handles.length - 1; n >= 0; n--)
      if (this.handles[n] === t) {
        this.handles.splice(n, 1);
        break;
      }
  }
  get current() {
    return this.handles[this.handles.length - 1];
  }
  getHandle() {
    return pe(this.current);
  }
  navigate(t, n) {
    this.getHandle().navigate(t, n);
  }
  replace(t, n) {
    this.getHandle().replace(t, n);
  }
  go(t, n) {
    this.getHandle().go(t, n);
  }
  back(t) {
    this.getHandle().back(t);
  }
  forward(t) {
    this.getHandle().forward(t);
  }
  setPathname(t, n) {
    this.getHandle().setPathname(t, n);
  }
  setSearch(t, n) {
    this.getHandle().setSearch(t, n);
  }
  setSearchParam(t, n, s) {
    this.getHandle().setSearchParam(t, n, s);
  }
  updateSearch(t, n) {
    this.getHandle().updateSearch(t, n);
  }
  setHash(t, n) {
    this.getHandle().setHash(t, n);
  }
  clearHash(t) {
    this.getHandle().clearHash(t);
  }
  run(t, n) {
    this.getHandle().run(t, n);
  }
}
const je = new fe(), q = {
  mark: Q("RouterContext"),
  create: () => {
    const e = x([]);
    return {
      value: e,
      dispose: () => e.dispose()
    };
  }
}, me = (e, t, n) => {
  const s = n.split("/").filter((r) => r !== ""), a = {};
  let o = 0;
  for (let r = 0; r < e.length; r++) {
    const i = e[r], c = s[r];
    if (!c && i.type !== "catch-all")
      return null;
    if (i.type === "literal") {
      if (i.value !== c)
        return null;
      o++;
    } else if (i.type === "param")
      a[i.name] = c, o++;
    else if (i.type === "catch-all") {
      i.name && (a[i.name] = s.slice(o).join("/"));
      const u = "/" + s.slice(0, o).join("/"), h = "/" + s.slice(o).join("/");
      return {
        params: a,
        matchedPath: u === "/" ? "" : u,
        remainingPath: h === "/" ? "" : h,
        route: t
      };
    }
  }
  if (s.length === e.length) {
    const r = "/" + s.join("/");
    return {
      params: a,
      matchedPath: r === "/" ? "" : r,
      remainingPath: "",
      route: t
    };
  }
  return null;
}, Et = (e) => {
  const t = e.map((n) => {
    const s = Pt(n);
    return { route: n, segments: s };
  });
  return function(s) {
    for (const { segments: a, route: o } of t) {
      const r = me(a, o, s);
      if (r)
        return r;
    }
    return null;
  };
}, _e = (e) => {
  const t = Et(Object.keys(e));
  return Ht(
    q,
    {},
    () => N(G, (n) => N(q, (s) => {
      const a = n.location.map((o) => {
        const r = t(o.pathname);
        if (r == null)
          throw console.error("No route found for", o), new Error("No route found");
        const i = {
          matchedPath: r.matchedPath,
          remainingPath: r.remainingPath,
          fullPath: o.pathname,
          params: r.params
        };
        return s.value = [...s.value, i], {
          params: r.params,
          route: r.route,
          path: r.matchedPath || o.pathname,
          search: o.search,
          hash: o.hash
        };
      });
      return yt(
        a.map((o) => [o.route, o]),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        e
      );
    }))
  );
}, Ie = (e) => {
  const t = Et(Object.keys(e));
  return N(q, (n) => N(G, (s) => {
    const a = n.map((o) => {
      const r = o[o.length - 1];
      if (r == null)
        throw console.error("No router context available for ChildRouter", o), new Error("No router context available for ChildRouter");
      const i = r.remainingPath ?? "", c = t(i);
      if (c == null)
        throw console.error("No route found for remaining path", i), new Error("No route found");
      return {
        params: c.params,
        // Only this router's parameters
        route: c.route,
        path: c.matchedPath,
        search: s.location.value.search,
        hash: s.location.value.hash
      };
    });
    return yt(
      a.map((o) => [o.route, o]),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      e
    );
  }));
}, z = 60 * 1e3, Y = 60 * z, F = 24 * Y, ut = 7 * F, ht = 30 * F, ge = 365 * F, ve = [
  {
    max: z * 90,
    value: z,
    name: "minute",
    past: { singular: "a minute ago", plural: "{} minutes ago" },
    future: { singular: "in a minute", plural: "in {} minutes" }
  },
  {
    max: Y * 36,
    value: Y,
    name: "hour",
    past: { singular: "an hour ago", plural: "{} hours ago" },
    future: { singular: "in an hour", plural: "in {} hours" }
  },
  {
    max: F * 10,
    value: F,
    name: "day",
    past: { singular: "yesterday", plural: "{} days ago" },
    future: { singular: "tomorrow", plural: "in {} days" }
  },
  {
    max: ut * 6,
    value: ut,
    name: "week",
    past: { singular: "last week", plural: "{} weeks ago" },
    future: { singular: "in a week", plural: "in {} weeks" }
  },
  {
    max: ht * 18,
    value: ht,
    name: "month",
    past: { singular: "last month", plural: "{} months ago" },
    future: { singular: "in a month", plural: "in {} months" }
  },
  {
    max: 1 / 0,
    value: ge,
    name: "year",
    past: { singular: "last year", plural: "{} years ago" },
    future: { singular: "in a year", plural: "in {} years" }
  }
];
function dt(e, t, n, s) {
  const a = Math.round(e / t);
  return a <= 1 ? n : s.replace(
    "{}",
    a.toLocaleString(void 0, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    })
  );
}
const we = (e = 1e3) => {
  const t = x(/* @__PURE__ */ new Date()), n = Ut(() => t.set(/* @__PURE__ */ new Date()), e);
  return t.onDispose(n), t;
}, ye = (e) => {
  const t = Math.abs(e);
  if (t < z)
    return e < 0 ? "just now" : "in a moment";
  for (const n of ve)
    if (t < n.max)
      return e < 0 ? dt(t, n.value, n.past.singular, n.past.plural) : dt(t, n.value, n.future.singular, n.future.plural);
  throw new Error("unreachable");
}, Se = (e, { now: t, frequency: n = 1e4 } = {}) => {
  const s = t != null ? pt.is(t) ? t.derive() : x(t) : we(n), a = J(
    e,
    s
  )((o, r) => o.getTime() - r.getTime());
  return a.onDispose(() => k.dispose(s)), a;
}, ke = (e, t = {}) => {
  const n = Se(e, t), s = n.map(ye);
  return s.onDispose(() => n.dispose()), s;
}, Be = (e, t = {}) => ke(e, t);
class xe extends Tt {
  /**
   * Triggers an update of the Ticker by incrementing its internal value.
   * @returns void
   */
  tick = () => this.update((t) => t + 1);
}
const qe = (e = 0) => new xe(e, Wt);
export {
  te as Anchor,
  Oe as Appearance,
  xt as AsyncResultView,
  Le as AutoFocus,
  Re as AutoSelect,
  Ie as ChildRouter,
  ze as ElementRect,
  Te as HTMLTitle,
  He as HiddenWhenEmpty,
  re as InViewport,
  G as Location,
  Me as Mutation,
  ce as MutationDisplay,
  je as NavigationService,
  ae as OnClickOutside,
  Ue as OnEnterKey,
  Ke as OnEscapeKey,
  bt as OnKeyPressed,
  Ne as PopOver,
  Fe as Query,
  ue as QueryDisplay,
  V as Rect,
  he as ResultView,
  _e as RootRouter,
  q as RouterContextProvider,
  Ce as SelectOnFocus,
  xe as Ticker,
  We as WhenInViewport,
  Ve as WindowSize,
  Vt as _checkExtensionCondition,
  zt as _getExtension,
  $e as _makeRouteMatcher,
  Pt as _parseRouteSegments,
  De as allPlacements,
  _t as areLocationsEqual,
  Ae as classes,
  ot as evaluateLocationMatch,
  ct as getAbsoluteRect,
  jt as handleAnchorClick,
  I as locationFromURL,
  ie as makeMutationResource,
  le as makeQueryResource,
  oe as matchesKeyCombo,
  de as matchesRoute,
  we as nowSignal,
  Be as relativeTime,
  Se as relativeTimeMillisSignal,
  ke as relativeTimeSignal,
  qe as ticker,
  ye as timeDiffToString,
  U as urlFromLocation,
  ee as useAppearance
};
